module.exports = __webpack_public_path__ + "static/media/iot4.34b37162.svg";